import { component, action, getter } from '../../decorators';

import {
   SHOW_LOAD_METADATA,
   SHOW_SUCCESS_NOTIFICATION,
   SHOW_INFO_NOTIFICATION,
   CART_LOAD,
   CART_LOAD_BY_ID
} from '../../store/actions';

import { REFRESH_CART } from '../../store/mutation-types';

import { SOCKET_PATH } from '../../config';

import l10n from '../../transformers/l10n';

const PING_STATE_TIMEOUT = 15000;
const CHECK_STATE_TIMEOUT = 2000;
const RECONNECT_TIMEOUT = 1000;
const OK = 1;

@component({
   watch: {
      getCurrentShow: {
         handler: 'humanizePathIfNeeded',
         immediate: true
      }
   }
})
export default class Library {
   @action(SHOW_LOAD_METADATA) loadMetadata
   @action(SHOW_SUCCESS_NOTIFICATION) notify
   @action(SHOW_INFO_NOTIFICATION) info
   @action(CART_LOAD) reloadCarts
   @action(CART_LOAD_BY_ID) reloadCart

   @getter() isProcessingCart
   @getter() getCurrentShow

   socket = null
   connected = false
   timeoutId = null
   pingTimeoutId = null
   startingTimeoutId = null

   get showId() {
      return this.$route.params.mid;
   }

   humanizePathIfNeeded() {
      const show = this.getCurrentShow;
      if (/^\d*$/.test(this.showId) && show) {
         const { name, params } = this.$route;
         this.$router.push({ name, params: { ...params, mid: show.route ? show.route : show.id } });
      }
   }

   startListening() {
      if (this.socket && this.socket.readyState === OK) {
         return;
      }
      this.socket = new WebSocket(`${SOCKET_PATH}/push`);
      this.socket.onopen = this.onopen;
      this.socket.onmessage = this.onmessage;
      this.socket.onerror = this.onerror;
      this.socket.onclose = this.onclose;
   }

   stopListening() {
      const { socket } = this;
      if (socket) {
         socket.onclose = _empty;
         this.socket = null;
         socket.close();
      }
   }

   onopen() {
      this.connected = true;
      this.socket.send('/cl/orders/status');
      this.socket.send('/cl/orders/sharing');
      this.checkState();
      this.ping();
   }

   checkState() {
      const that = this;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
         if(!that.socket) {
            return;
         }
         
         if (that.connected && that.socket.readyState === OK) {
            that.checkState();
         } else {
            that.connected = false;
            that.startListening();
         }
      }, CHECK_STATE_TIMEOUT);
   }

   ping() {
      const that = this;
      clearTimeout(this.pingTimeoutId);
      this.pingTimeoutId = setTimeout(() => {
         if(!that.socket) {
            return;
         }

         if (that.connected && that.socket.readyState === OK) {
            that.socket.send('PING');
            that.ping();
         }
      }, PING_STATE_TIMEOUT);
   }

   onmessage(evt) {
      var msg = JSON.parse(evt.data);

      switch (msg.type) {
         case 'dcl:os:carts.status':
            var { id, progress, status, updatedDate, name } = msg;
            if (status === 'ready') {
               this.notify(l10n('cart.ready', { name }));
            }
            this.$store.commit(REFRESH_CART, { id, progress, status, updatedDate });
            break;
         case 'dcl:os:carts.shared':
            this.info(l10n('cart.push.carts.shared', { sharedByName: msg.sharedByName, cartName: msg.cartName }));
            this.reloadCarts();
            break;
         case 'dcl:os:carts.unshared':
            this.info(l10n('cart.push.carts.unshared', { sharedByName: msg.sharedByName, cartName: msg.cartName }));
            this.reloadCarts();
            break;
         case 'dcl:os:carts.deleted':
            this.info(l10n('cart.push.carts.deleted', { userFullName: msg.userFullName, cartName: msg.cartName }));
            this.reloadCarts();
            break;
         case 'dcl:os:carts.checkouted':
            this.info(l10n('cart.push.carts.checkouted', { userFullName: msg.userFullName, cartName: msg.cartName }));
            break;
         case 'dcl:os:carts.clips.added':
            this.info(l10n('cart.push.carts.clips.added', { userFullName: msg.userFullName, cartName: msg.cartName }));
            this.reloadCart(msg.cartId);
            break;
         case 'dcl:os:carts.clips.removed':
            this.info(l10n('cart.push.carts.clips.removed', { userFullName: msg.userFullName, cartName: msg.cartName }));
            this.reloadCart(msg.cartId);
            break;
      }
   }

   onerror() {
      if (!this.connected) {
         this.startDelay();
      }
   }

   onclose() {
      this.connected = false;
      this.startDelay();
   }

   startDelay() {
      clearTimeout(this.timeoutId);
      clearTimeout(this.startingTimeoutId);
      this.startingTimeoutId = setTimeout(this.startListening, RECONNECT_TIMEOUT);
   }

   created() {
      this.loadMetadata(this.showId);
      this.startListening();
   }

   beforeDestroy() {
      this.stopListening();
   }
}

function _empty() {
   //
}
